import React, { useState, useEffect } from 'react';
import {useParams, useNavigate } from "react-router-dom";
import Footer from './Footer.js';
import LoadingAnimation from './LoadingAnimation';

import GameContainer from './GameContainer';
import * as utils from '../common/Utils.js'
import { useLeagueData } from '../contexts/LeagueDataContext.js';
import { useConfig } from '../contexts/ConfigContext.js';

const Schedule = () => {
  const { teamID, seasonID } = useParams();
  const navigate = useNavigate();
  const { teams: allTeams, seasonTeams: allSeasonTeams, games: allGames, dataLoaded } = useLeagueData(['teams', 'seasonTeams', 'games']);
  const config = useConfig();
  const season = seasonID || config.currentSeason;

  const [games, setGames] = useState([])
  const [teams, setTeams] = useState([])
  const [dataReady, setDataReady] = useState(false);

  useEffect(() => {
    if (!dataLoaded) return;

    const seasonTeamsForSeason = allSeasonTeams.filter(st => st.season == season);
    const seasonTeamIDs = seasonTeamsForSeason.map(st => st.teamID);
    setTeams(allTeams
      .filter(t => seasonTeamIDs.includes(t.id))
      .map(t => {
        const st = seasonTeamsForSeason.find(st => st.teamID === t.id);
        return { ...t, seed: st?.seed || '' };
      })
    );

    let filtered = allGames.filter(g => g.season == parseInt(season));
    if (!seasonID) {
      filtered = filtered.filter(g => g.status !== 'pending');
    }
    setGames(filtered);
    setDataReady(true);
  }, [dataLoaded, allTeams, allGames]);

  useEffect(() => {
    if (dataReady && !teamID) {
      let today = Date.now();
      const finishedGames = games.filter((game) => (['completed', 'postponed'].includes(game.status) || game.date <= today) && (game.awayTeamID !== '' && game.homeTeamID !== ''))

      const offset = (finishedGames.length * 78) - 310

      window.scrollTo({
        top: offset,
        behavior: "instant"
      })
    }
  }, [dataReady]);

  function displayGames () {
    let today = Date.now();
    let oneWeek = today + (7 * 24 * 60 * 60 * 1000);
    let gamesThisWeek;
    let finishedGames;
    if (teamID) {
      gamesThisWeek = games.filter((game) => (!['completed', 'postponed', 'cancelled'].includes(game.status) && game.date > today) && (game.awayTeamID === teamID || game.homeTeamID === teamID))
      finishedGames = games.filter((game) => (['completed', 'postponed', 'cancelled'].includes(game.status) || game.date <= today) && (game.awayTeamID === teamID || game.homeTeamID === teamID) && (game.awayTeamID !== '' && game.homeTeamID !== ''))
    } else {
      gamesThisWeek = games.filter((game) => !['completed', 'postponed', 'cancelled'].includes(game.status) && game.date > today && (game.awayTeamID !== '' && game.homeTeamID !== ''))
      finishedGames = games.filter((game) => game.date <= today || ['completed', 'postponed', 'cancelled'].includes(game.status) )
    }
    // if (gamesThisWeek.length == 0 && finishedGames.length < allGames.length) {
    //   return <p>No upcoming games this week</p>
    // }
    let sortedGamesThisWeek = gamesThisWeek.sort((a, b) => (a.date < b.date) ? -1 : 1)
    let sortedFinishedGames = finishedGames.sort((a, b) => (a.date < b.date) ? -1 : 1)

    let gameElements = sortedGamesThisWeek.map((game, place) => {
      return (
        <GameContainer games={games} teams={teams} gameID={game.id}></GameContainer>
      )
    })
    let gameOverElements = sortedFinishedGames.map((game, place) => {
      return (
        <GameContainer games={games} teams={teams} gameID={game.id}></GameContainer>
      )
    })
    return (
      <>
        { gameOverElements }
        { gameElements }
      </>
    );
  }

  // MOVED TO UTILS.JS

  function getRecordForID (given_id = null) {
    let team_id = given_id === null ? teamID : given_id

    if (team_id) {
      let allGames = games.filter((game) => game.status === 'completed' && game.season == season  && (game.awayTeamID === team_id || game.homeTeamID === team_id))
      let allGamesWon = games.filter((game) => game.status === 'completed' && game.season == season && (game.winner === team_id))
      let gamesPlayed = allGames.length;
      let gamesWon = allGamesWon.length;
      return `${gamesWon}-${gamesPlayed - gamesWon}`
    } else {
      return '';
    }
  }


  function displayDropdown (team) {
    let href = `/schedule/teams/${team.id}`

    if (seasonID) {
      href = `/schedule/seasons/${seasonID}/teams/${team.id}`
    }

    return (
      <>
        { !teamID && <li><a className="dropdown-item"  href={ href }>{ team.name.toUpperCase()}</a></li> }
        { teamID && teamID === team.id && <li><a className="dropdown-item"  href={"/schedule/teams/" + team.id }><b>{ team.name.toUpperCase()}</b></a></li> }
        { teamID && teamID !== team.id && <li><a className="dropdown-item"  href={"/schedule/teams/" + team.id }>{ team.name.toUpperCase()}</a></li> }
      </>
    )
  }
  function displayTeamNameDropdown () {
    let teamDropdownElements = teams.map((team, place) => displayDropdown(team))
    return teamDropdownElements;
  }

  if (dataReady == false) {
    return (
      <div className="Schedule">
        <LoadingAnimation />
      </div>
    )
  } else {
    return (
      <div className="Schedule">
        <div className="league-content">

          <div className="league-body">
            <p className="league-title-standard-secondary text-align-center">Schedule</p>
            <div className="dropdown league-dropdown">
              <button className="btn btn-secondary dropdown-toggle" type="button" id="teamScheduleDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                { teamID ? utils.getTeamForID(teams, teamID).name.toUpperCase() : "Select a team" }
              </button>
              <ul className="dropdown-menu" aria-labelledby="teamScheduleDropdown">
                { displayTeamNameDropdown() }
              </ul>
            </div>
            { teamID && <a className="league-type league-mini-header-link" href="/schedule">All Games</a> }
            { teamID && <p className="league-title-standard-small text-align-center no-margin">Record: {getRecordForID()}</p>}
            <div className="league-table-container schedule">
              { games.length > 0 ? displayGames() : 'No games scheduled for the season yet...'}
            </div>
          </div>

        </div>

        <Footer/>
      </div>
    );
  }
}

export default Schedule;
